import { Injectable } from '@angular/core';

import { GridFlavorEnum } from '../../../enums/grid.enums';
import { RegularGridFlavor } from './regular-grid-flavor';
import { AttachmentsGridFlavor } from './attachments-grid-flavor';
import { ContactsGridFlavor } from './contacts-grid-flavor';

@Injectable({
    providedIn: 'root'
})
export class GridFlavorFactory {

    public static getImplementation(flavor: GridFlavorEnum) {
        if (flavor == GridFlavorEnum.RegularGrid) {
            return new RegularGridFlavor();
        } else if (flavor == GridFlavorEnum.AttachmentsGrid) {
            return new AttachmentsGridFlavor();
        } else if (flavor == GridFlavorEnum.ContactsGrid) {
            return new ContactsGridFlavor();
        }
    }
}
